<ngx-zero-state class="zero-state-data-source-empty" *ngIf="(activityListDataSource.loading$ | async) !== true">
    <p zero-state-title>{{getTitle() | async}}</p>
	<p zero-state-subtext>{{getSubText() | async}}</p>

    <div zero-state-body class="zero-state-body">
		<button *ngIf="!isLti() && hasInstructorRoleOrAbove && (isFiltering$ | async) !== true"
			data-cy="zero-invite-btn"
			class="secondary-btn zero-invite-btn"
			(click)="openInvite.emit()">
			{{'common_invite' | translate}}
		</button>
		<span
			[tabindex]="(canCreateActivity$$ | async) ? -1 : 0"
			[matTooltip]="getActivityCreationDisabledMessage$$ | async"
			[matTooltipDisabled]="canCreateActivity$$ | async"
			[attr.aria-disabled]="(canCreateActivity$$ | async) !== true"
			matTooltipPosition="above"
			[attr.role]="(canCreateActivity$$ | async) !== true ? 'button' : ''">
			<button
				*ngIf="hasInstructorRoleOrAbove && (isFiltering$ | async) !== true"
				class="btn primary-btn manage-btn eligible-btn"
				data-cy="create-activity"
				translate="folder_view-create_button"
				[disabled]="(canCreateActivity$$ | async) !== true"
				(click)="openAssignmentSourceModal.emit()"
				[attr.aria-hidden]="(canCreateActivity$$ | async) !== true">
			</button>
		</span>
    </div>

    <div zero-state-graphic-bottom>
        <img
			class="instructor-image"
			src="https://staticassets.goreact.com/Rocket.svg"
			[attr.alt]="'group-view_zero-state-data-source-empty-title-instructor-without-filter' | translate"
			*ngIf="selectedService.getGroup().hasInstructorRole(true) && (isFiltering$ | async) !== true"
		>

        <img
			class="presenter-image"
			src="https://staticassets.goreact.com/astronaut-astroid.svg"
			[attr.alt]="'group-view_zero-state-data-source-empty-title-presenter' | translate"
			*ngIf="selectedService.getGroup().hasPresenterRole()"
		>
    </div>
</ngx-zero-state>
